import { createContext, useContext } from 'react';

export const AddendumModeContext = createContext({
  allAddendums: [],
  medicalHistoryId: null,
  patientId: null,
  isLocked: false,
  isAddendumMode: false,
  addendumId: null,
  draft: null,
  draftIndex: null,
  addendumOverrides: null,
  addendumDraft: {},
  hasSignableChanges: false,
  signableClassification: null,
  draftWithForms: null,
  isAddendumFormsLoading: false,
  isAddendumHydrating: false,
  setAddendumDraftField: () => {},
  resetAddendumDraft: () => {},
  loadForm: () => {},
  isFormLoaded: () => false,
  invalidateAddendumQueries: () => {},
  beginBulkSave: () => {},
  endBulkSave: () => {},
  signedAddendums: null,
  isSignModalOpen: false,
  isExitConfirmOpen: false,
  isAddendumDirty: false,
  isCreating: false,
  isSigning: false,
  isDiscarding: false,
  enter: () => {},
  exit: () => {},
  clearAddendum: () => {},
  sign: () => {},
  discard: () => {},
  requestExit: () => {},
  discardChanges: () => {},
  closeExitConfirm: () => {},
  openSignModal: () => {},
  closeSignModal: () => {}
});

export const useAddendumModeContext = () => useContext(AddendumModeContext);
